export default __webpack_public_path__ + "static/media/help.d39774e9.png";